import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Going from Slovenia to Palo Alto ... what culture shock?",
  "description": "",
  "published": "2011-07-14T00:00:00.000Z",
  "redirect_from": ["/blog/going-from-slovenia-to-palo-alto-what-culture-shock/swizec/1947"],
  "categories": "Entrepreneur, Ljubljana, London, Palo Alto California, Slavoj Žižek, Slovenia, Uncategorized, United States, University Street",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The drink/coffee meetings resulting from my post about coming to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.4291666667,-122.138055556&spn=0.1,0.1&q=37.4291666667,-122.138055556%20(Palo%20Alto%2C%20California)&t=h",
        "title": "Palo Alto, California"
      }}>{`Palo Alto`}</a>{` have started happening. It's great fun meeting new people and getting a feel for the local community and entrepreneurial scene. Certainly a great place to be for meeting cool people and hackers.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/300px-Palo_Alto%2C_California_%28City_Hall%29_2004.jpg",
        "alt": "Photograph of Palo Alto City Hall.",
        "title": "Photograph of Palo Alto City Hall."
      }}></img></p>
    <p>{`Invariably, though, the conversation comes up to a point where they decide to finally notice my thick accent (it's actually kind of horrible, I thought I could speak much better than I can) and ask about where I'm from.`}</p>
    <p>{`A surprising number of people recognize the country.`}</p>
    <p>{`Or pretend to.`}</p>
    <p>{`Hard to tell which, but it doesn't really matter. It's much different than just four years ago going to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=51.5072222222,-0.1275&spn=0.1,0.1&q=51.5072222222,-0.1275%20(London)&t=h",
        "title": "London"
      }}>{`London`}</a>{` and having pretty much everyone ask where the fuck is this `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.05,14.5&spn=10.0,10.0&q=46.05,14.5%20(Slovenia)&t=h",
        "title": "Slovenia"
      }}>{`Slovenia`}</a>{` thing. Maybe there's a lot of Slovenians in Palo Alto, or maybe `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=38.8833333333,-77.0166666667&spn=10.0,10.0&q=38.8833333333,-77.0166666667%20(United%20States)&t=h",
        "title": "United States"
      }}>{`Americans`}</a>{` just don't care as much where a particular country might be situated.`}</p>
    <p>{`And the next step in this conversation is predictably: "So that's a pretty big step huh, moving all the way over here? How do you like it?"`}</p>
    <p>{`To be honest ... I don't really notice a difference. I think this has so far disappointed pretty much everywhere.`}</p>
    <p>{`But seriously, the US is not that different than home. Sure, everything here is like Slovenia on steroids. Everything is huge. There are more people. Going to the store around the corner is a two kilometer bike ride. And something being "right next to the `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=37.8180555556,-122.346666667&spn=0.01,0.01&q=37.8180555556,-122.346666667%20(San%20Francisco%20%E2%80%93%20Oakland%20Bay%20Bridge)&t=h",
        "title": "San Francisco – Oakland Bay Bridge"
      }}>{`Bay Bridge`}</a>{`" is the whole of `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=46.0555555556,14.5083333333&spn=0.1,0.1&q=46.0555555556,14.5083333333%20(Ljubljana)&t=h",
        "title": "Ljubljana"
      }}>{`Ljubljana`}</a>{` away from the actual bridge.`}</p>
    <p>{`That's to be expected though. The US is a big vast country and land is pretty much worthless. Back in Europe land is practically the hardest thing to come by so naturally everything is a bit smaller. Our cities also tend to be much more centralized due to historical reasons that just didn't exist here (think wars with pitchforks and swords).`}</p>
    <p>{`Maybe I live in a strange bubble full of entrepreneurs back home, but aside from being a couple of sizes bigger the scene here doesn't seem much different than in Ljubljana.`}</p>
    <p>{`Here you can talk to a random person in a bar on `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=45.503518,-73.570496&spn=1.0,1.0&q=45.503518,-73.570496%20(University%20Street)&t=h",
        "title": "University Street"
      }}>{`University Street`}</a>{` and they will tell you they're an entrepreneur. They might even pitch into your conversation if they hear something awesome. This is something we don't have at home. But go to the right bar, and you do.`}</p>
    <p>{`In Ljubljana there is a bar that a lot of the tech entrepreneurs visit somewhat regularly. In California Palo Alto `}<em parentName="p">{`is`}</em>{` that bar.`}</p>
    <p>{`See, just a bit bigger. :)`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/300px-Slavoj_Zizek_in_Liverpool_cropped1.jpg",
        "alt": "Slavoj Zizek in Liverpool, cropped version of ...",
        "title": "Slavoj Zizek in Liverpool, cropped version of ..."
      }}></img></p>
    <p>{`Really the biggest culture shock I did notice revolves around food and such things.`}</p>
    <p>{`People here are just simply bonkers. Everything, fucking `}<em parentName="p">{`everything`}</em>{` has all these magical labels about what is or isn't in there. And everything is just so fake and horrible ... seriously, we even found flour that promised to be at least 20% made of flour!`}</p>
    <p>{`Seriously.`}</p>
    <p>{`And all the propaganda! Marmelade markets itself as having zero calories from fat ... meat markets itself as zero calories from sugars ... My mind is blown literally every time I try to figure out what I'm actually eating.`}</p>
    <p>{`Luckily we found a store barely 20 kilometers from the house that sells nice, normal, balkan food.`}</p>
    <p>{`Oh and a surprising amount of people I meet are really into Slavoj Žižek ... I find that somewhat odd.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=6d7178c7-83df-4c33-81ba-285822b49d72",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      